// # https://vcalendar.io/guide/
import Vue from 'vue'
import VCalendar, { DatePicker } from 'v-calendar'

Vue.use(VCalendar, {
  components: {
    DatePicker
  }
})
